import React from 'react'
import { renderToString } from 'react-dom/server'

export function filterCurrentUserFromMembers(members, userId) {
  let filteredMembers = members.members
  delete filteredMembers[userId]
  return filteredMembers
}

export function mapChannelMembers(members) {
  let retVal = []
  Object.keys(members).forEach(m => {
    retVal.push({
      id: m,
      name: members[m].name
    })
  })
  return retVal
}

export function formatModalWarningMessageProp(members, userId) {
  const filteredMappedMembers = mapChannelMembers(
    filterCurrentUserFromMembers(members, userId)
  )
  let membersMessage = {}
  filteredMappedMembers.length === 1
    ? (membersMessage = (
        <span>
          <strong>{filteredMappedMembers[0].name}</strong> is{' '}
        </span>
      ))
    : (membersMessage = filteredMappedMembers.map((m, i) => {
        const length = filteredMappedMembers.length
        if (length > 2 && i < length - 1) {
          return (
            <span key={2}>
              <strong>{m.name}</strong>,{' '}
            </span>
          )
        } else if (length === 2 && i < length - 1) {
          return (
            <span key={2}>
              <strong>{m.name}</strong>{' '}
            </span>
          )
        } else {
          return (
            <span key={3}>
              and <strong>{m.name}</strong> are{' '}
            </span>
          )
        }
      }))

  return renderToString(
    <span key={1}>
      {membersMessage} currently editing this page. Contact them to let them
      know you’d like to edit. If you edit this page, your changes or their
      changes could be lost.
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/utils/multipleeditors.js